export function interactionUid(search) {
  const uid = new URLSearchParams(search).get("uid");
  if (!uid || !/^[a-zA-Z0-9_-]{1,128}$/.test(uid)) {
    throw new Error("The authorization link is invalid. Restart from your MCP client.");
  }
  return uid;
}

export function continuationUrl(value, origin) {
  const url = new URL(value, origin);
  if (url.origin !== origin || !/^\/oauth\/auth\/[a-zA-Z0-9_-]{1,128}$/.test(url.pathname) ||
      url.username || url.password || url.hash || url.search) {
    throw new Error("The authorization service returned an invalid continuation.");
  }
  return url.href;
}

export async function oauthRequest(uid, action, body) {
  const response = await fetch(`/oauth/interaction/${encodeURIComponent(uid)}/${action}`, {
    method: body ? "POST" : "GET",
    credentials: "same-origin",
    cache: "no-store",
    redirect: "error",
    headers: body ? { "Content-Type": "application/json" } : {},
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Authorization failed. Restart from your MCP client if the request expired.");
  }
  return data;
}
